import { ShipmentSource } from "../../../core/models/app.enum";
export type AttachmentTypes = 'labels' | 'manifest' | 'consignment-notes' | 'all';
export class ConsignmentModel {
    id: number;
    consignmentNumber: string;
    yourReference: string;
    additionalReference: string;
    machshipId: string;
    stopStatusId: number;
    pickUpStopId: number;
    dropOffStopId: number;
    pickUpDuration: number;
    dropOffDuration: number;
    earliestPickup: string;
    latestPickup: string;
    pickUpTimesStrict: boolean;
    earliestDropOff: string;
    latestDropOff: string;
    dropOffTimesStrict: boolean;
    eta: string | null;
    recipientNotified: boolean;
    signature: string;
    proofOfDelivery: Array<string>;
    shiftId: number;
    serviceTypeId: number;
    vehicleTypeId: number | null;
    clientId: number;
    clientName: string;
    pickUpStopContactInformmation: string;
    dropOffStopContactInformation: string;
    distance: any;
    travelTime: number;
    shipmentItems: Array<any>;
    priceItems: Array<any>;
    shift: any;
    pickupStop: any;
    dropoffStop: any;
    stopStatusName: string;
    travelSummary: string;
    pickupNotes: string;
    pickupAdminNotes: string;
    pickupDriverNotes: string;
    dropOffNotes: string;
    dropOffAdminNotes: string;
    dropOffDriverNotes: string;
    dateFailed: string;
    dateIntransit: string;
    datePending: string;
    dateSkipped: string;
    dateSuccessful: string;
    clientInfo: any;
    isRowSelected: boolean;
    consignmentContractors: Array<any>;
    authorised: boolean;
    publishedRoles: Array<any>;
    publishedVehicles: Array<any>;
    macshipCharge: any;
    macshipPay: any;
    pickUpStateId: number;
    pickUpSuburb: string;
    dropOffStateId: number;
    dropOffSuburb: string;
    interestedContractors: Array<any>;
    tailgate: boolean;
    jockey: boolean;
    source: string;
    hydraulicTailgateRequired: boolean;
    isResidentialPickup: boolean;
    hydraulicTailgateDelivery: boolean;
    isImport: boolean;
    craneTruckRequired: boolean;
    handLoad: boolean;
    timeSlotBookingRequired: boolean;
    isExport: boolean;
    isResidentialDelivery: boolean;
    bookInRequired: boolean;
    phoneAhead: boolean;
    isReefer: boolean;
    handUnload: boolean;
    hydraulicTailgatePickup: boolean;
    custmJockeyRequired: boolean;
    premiumBookingRequired: boolean;
    sourceId: number;
    customerReference: string;

    constructor() {
        this.id = 0;
        this.consignmentNumber = '';
        this.yourReference = '';
        this.additionalReference = '';
        this.machshipId = '';
        this.stopStatusId = 0;
        this.pickUpStopId = 0;
        this.dropOffStopId = 0;
        this.pickUpDuration = 0;
        this.dropOffDuration = 0;
        this.earliestPickup = '';
        this.latestPickup = '';
        this.pickUpTimesStrict = false;
        this.earliestDropOff = '';
        this.latestDropOff = '';
        this.dropOffTimesStrict = false;
        this.eta = null;
        this.recipientNotified = false;
        this.signature = '';
        this.proofOfDelivery = [];
        this.shiftId = 0;
        this.serviceTypeId = 0;
        this.vehicleTypeId = null;
        this.clientId = 0;
        this.clientName = '';
        this.pickUpStopContactInformmation = '';
        this.dropOffStopContactInformation = '';
        this.distance = null;
        this.travelTime = 0;
        this.shipmentItems = []
        this.priceItems = [];
        this.shift = {};
        this.pickupStop = {};
        this.dropoffStop = {};
        this.stopStatusName = '';
        this.travelSummary = '';
        this.pickupNotes = '';
        this.pickupAdminNotes = '';
        this.pickupDriverNotes = '';
        this.dropOffNotes = '';
        this.dropOffAdminNotes = '';
        this.dropOffDriverNotes = '';
        this.dateFailed = '';
        this.dateIntransit = '';
        this.datePending = '';
        this.dateSkipped = '';
        this.dateSuccessful = '';
        this.clientInfo = {};
        this.isRowSelected = false;
        this.consignmentContractors = [];
        this.authorised = false;
        this.publishedRoles = [];
        this.publishedVehicles = [];
        this.macshipCharge = {};
        this.macshipPay = {};
        this.pickUpStateId = 0;
        this.pickUpSuburb = '';
        this.dropOffStateId = 0;
        this.dropOffSuburb = '';
        this.interestedContractors = [];
        this.tailgate = false;
        this.jockey = false;
        this.source = 'Admin Panel';
        this.hydraulicTailgateRequired = false;
        this.isResidentialPickup = false;
        this.hydraulicTailgateDelivery = false;
        this.isImport = false;
        this.craneTruckRequired = false;
        this.handLoad = false;
        this.timeSlotBookingRequired = false;
        this.isExport = false;
        this.isResidentialDelivery = false;
        this.bookInRequired = false;
        this.phoneAhead = false;
        this.isReefer = false;
        this.handUnload = false;
        this.hydraulicTailgatePickup = false;
        this.custmJockeyRequired = false;
        this.premiumBookingRequired = false;
        this.sourceId = ShipmentSource.ADMIN_PANEL,
        this.customerReference = '';
    }

    public static fromJson (data: any): ConsignmentModel {
        const model = new ConsignmentModel;
        /* Filter duplicate interested contractors */
        const seenInterested = new Set();
        const uniqueInterestedContractors = (data?.interested_contractors as any[])?.filter(item => {
            if (seenInterested.has(item.employee_id)) return false;
            seenInterested.add(item.employee_id);
            return true;
        }) ?? [];

        const dataSource = (data.source || '').toLowerCase().trim();
        Object.assign(model, {
            id: data.id,
            consignmentNumber: data.consignment_number,
            yourReference: data.your_reference ?? '',
            additionalReference: data.additional_reference ?? '',
            machshipId: data.machship_id,
            stopStatusId: data.stop_status_id,
            pickUpStopId: data.pickup_stop_id,
            dropOffStopId: data.dropoff_stop_id,
            pickUpDuration: data.pickup_duration,
            dropOffDuration: data.dropoff_duration,
            earliestPickup: data.earliest_pickup,
            latestPickup: data.latest_pickup,
            pickUpTimesStrict: data.pickup_times_strict,
            earliestDropOff: data.earliest_dropoff,
            latestDropOff: data.latest_dropoff,
            dropOffTimesStrict: data.dropoff_times_strict,
            eta: data.eta ?? null,
            recipientNotified: data.recipient_notified,
            signature: data.signature,
            proofOfDelivery: data.proof_of_delivery ?? [],
            shiftId: data.shift_id,
            serviceTypeId: data.service_type_id,
            vehicleTypeId: data.vehicle_type_id ?? null,
            clientId: data.client_id,
            clientName: '',
            pickUpStopContactInformmation: data.pickup_stop_contact_information,
            dropOffStopContactInformation: data.dropoff_stop_contact_information,
            distance: data.distance,
            travelTime: data.travel_time,
            shift: data.shift ?? null,
            shipmentItems: data.shipment_items ?? [],
            priceItems: data.price_items ?? [],
            pickupStop: data.pick_up_stop ?? null,
            dropoffStop: data.drop_off_stop ?? null,
            stopStatusName: '',
            travelSummary: '',
            pickupNotes: data.pickup_notes ?? '',
            pickupAdminNotes: data.pickup_admin_notes ?? '',
            pickupDriverNotes: data.pickup_driver_notes ?? '',
            dropOffNotes: data.dropoff_notes ?? '',
            dropOffAdminNotes: data.dropoff_admin_notes ?? '',
            dropOffDriverNotes: data.dropoff_driver_notes ?? '',
            dateFailed: data.date_failed ?? '',
            dateIntransit: data.date_intransit ?? '',
            datePending: data.date_pending ?? '',
            dateSkipped: data.date_skipped ?? '',
            dateSuccessful: data.date_successful ?? '',
            clientInfo: data.customer_branch ?? null,
            consignmentContractors: data.consignment_contractors ?? [],
            authorised: data.authorised ?? false,
            publishedRoles: data.published_roles ?? [],
            publishedVehicles: data.published_vehicles ?? [],
            macshipCharge: data.machship_charge_rates ?? null,
            macshipPay: data.machship_pay_rates ?? null,
            pickUpStateId: data.pickup_state,
            pickUpSuburb: data.pickup_suburb,
            dropOffStateId: data.dropoff_state,
            dropOffSuburb: data.dropoff_suburb,
            interestedContractors: uniqueInterestedContractors,
            tailgate: Boolean(data.tailgate),
            jockey: Boolean(data.jockey),
            sourceId: dataSource == 'admin panel' ? ShipmentSource.ADMIN_PANEL : (dataSource == 'cp - jobs' ? ShipmentSource.CPJOBS : ShipmentSource.MACHSHIP),
            hydraulicTailgateRequired: Boolean(data.hydraulic_tailgate_required),
            isResidentialPickup: Boolean(data.is_residential_pickup),
            hydraulicTailgateDelivery: Boolean(data.hydraulic_tailgate_delivery),
            isImport: Boolean(data.is_import),
            craneTruckRequired: Boolean(data.crane_truck_required),
            handLoad: Boolean(data.hand_load),
            timeSlotBookingRequired: Boolean(data.time_slot_booking_required),
            isExport: Boolean(data.is_export),
            isResidentialDelivery: Boolean(data.is_residential_delivery),
            bookInRequired: Boolean(data.book_in_required),
            phoneAhead: Boolean(data.phone_ahead),
            isReefer: Boolean(data.is_reefer),
            handUnload: Boolean(data.hand_unload),
            hydraulicTailgatePickup: Boolean(data.hydraulic_tailgate_pickup),
            custmJockeyRequired: Boolean(data.custm_jockey_required),
            premiumBookingRequired: Boolean(data.premium_booking_required),
            customerReference: data.customer_reference ?? null
        });
        return model;
    }
}